export const META_KEY = {
  TELEGRAM_SUPPORT_BOT_URL: 'telegram_support_bot_url',
  PAYOUT_MAX_ACTIVE_ORDERS: 'payout_max_active_orders',
  ORDERS_MONITORING_ENABLED: 'orders_monitoring_enabled',
  PAYOUT_ORDER_AVAILABLE_REJECT_STATUS_DETAILS_LIST:
    'payout_order_available_reject_status_details_list',
  PAYIN_REQUISITES_VERIFICATION_REQUIRED:
    'payin_requisites_verification_required',
  PAYIN_REQUISITES_VERIFICATION_EXPIRATION_AFTER:
    'payin_requisites_verification_expiration_after',
  TRADER_CAN_OPEN_DISPUTE: 'trader_can_open_dispute',
  TRADER_CAN_CANCEL_DISPUTE: 'trader_can_cancel_dispute',
  TRADER_CAN_COMPLETE_CANCELLED: 'trader_can_complete_cancelled',
  ORDER_AUTOMATION_API_HOST: 'order_automation_api_host',
  TURBO_DEPOSIT_ENABLED: 'turbo_deposit_enabled',
  MULTITRANSFER_ENABLED: 'multitransfer_enabled',
  CARTEL_HOUSE_SMS_ENABLED: 'cartel_house_sms_enabled',
  TECH_PROTECTION_RECEIPTS_VALIDATION_ENABLED:
    'tech_protection_receipts_validation_enabled',
  CHEQUE_WALES_ENABLED: 'cheque_wales_enabled',
  SHOP_TABS_ENABLED: 'shop_tabs_enabled',
  SHOP_WEBHOOK_OVERRIDES_ENABLED: 'shop_webhook_overrides_enabled',
  USE_DEEP_LINK_PAYMENT_PAGE_SETTING_ENABLED:
    'use_deep_link_payment_page_setting_enabled',
  INCLUDE_DEEPLINK_IN_RESPONSE_ALLOWED: 'include_deeplink_in_response_allowed',
  SCI_AVAILABLE_TEMPLATE_LIST: 'sci_available_template_list',
  SCI_AVAILABLE_THEME_LIST: 'sci_available_theme_list',
  PAYOUT_VOLUME_CONTROL_ENABLED: 'payout_volume_control_enabled',
  P2P_PROVIDER_CAN_IGNORE_ORDER_TRADE_METHOD:
    'p2p_provider_can_ignore_order_payment_type',
  REQUIRED_2FA_FOR_ROLES: 'required_2fa_for_roles',
  SCI_CUSTOMER_ALTERNATIVES_ENABLED: 'sci_customer_alternatives_enabled',
  CLARITY_ENABLED: 'clarity_enabled',
  CLARITY_SHOP_DEFAULT_ENABLED: 'clarity_shop_default_enabled',
  PAYOUT_ORDER_CASCADE_TIMEOUT_ENABLED: 'payout_order_cascade_timeout_enabled',
  PAYOUT_MANUAL_DISTRIBUTION_ENABLED: 'payout_manual_distribution_enabled',
  MERCHANT_CAN_CREATE_PAYOUT_ORDER: 'merchant_can_create_payout_order',
  DYNAMIC_ADAPTERS_ENABLED: 'dynamic_adapters_enabled',
  PROVIDER_AGENTS_ENABLED: 'provider_agents_enabled',
  PROVIDER_INTERVAL_COMMISSIONS_ENABLED:
    'provider_interval_commissions_enabled',
  PAYIN_ORDER_P2P_OVERRIDE_KEYS: 'payin_order_p2p_override_keys',
  TOKEN_IP_VALIDATION_ENABLED: 'token_ip_validation_enabled',
  MERCHANT_OPERATORS_ENABLED: 'merchant_operators_enabled',
  OPERATOR_TRADER_ACTIONS_ENABLED: 'operator_trader_actions_enabled',
  ZERO_FEES_FORBIDDEN: 'zero_fees_forbidden',
  PAYIN_PROVIDER_CONVERSION_STATISTICS_ENABLED:
    'payin_provider_conversion_statistics_enabled',
  GPT_TEMPLATE_GENERATION_ENABLED: 'gpt_template_generation_enabled',
  P2P_PROVIDER_IGNORE_WEBHOOK_ALLOWED: 'ignore_p2p_provider_webhook_allowed',
  NEGATIVE_PROFIT_ALLOWANCE_ENABLED: 'negative_profit_allowance_enabled',
  DISPUTE_REPAYMENT_ENABLED: 'dispute_repayment_enabled',
};
